<div class="maia-overlay" data-testid="maia-leave-dialog" (click)="stay.emit()">

    <div class="leave-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

        <button type="button"
                class="dialog-close"
                data-testid="maia-leave-dialog-close"
                aria-label="Close"
                (click)="stay.emit()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
                <path d="m9.5 9.5 5 5M14.5 9.5l-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
        </button>

        <span class="dialog-icon" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M12 4.5 21 20H3z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
                <path d="M12 10v4.5M12 17v.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
            </svg>
        </span>

        <h2 class="dialog-title">Leave this page?</h2>

        <p class="dialog-text">
            If you go back now, your uploaded SOV and all unsaved progress will be lost.
            You'll need to upload the file again to continue.
            <strong>This action is not recommended.</strong>
        </p>

        <button type="button"
                class="dialog-button dialog-button-primary"
                data-testid="maia-stay-on-page-button"
                (click)="stay.emit()">
            Stay on this page
        </button>

        <button type="button"
                class="dialog-button dialog-button-secondary"
                data-testid="maia-leave-without-saving-button"
                (click)="leave.emit()">
            Leave without saving
        </button>

    </div>
</div>
